import React, { useState, useEffect } from "react";
// import arrR from "../Assests/alratv_img/arrow-right.png";
import arrR from "../Assests/right-arrow.svg";
import qrCode from "../Assests/qr_5kA17AcGfgIRaCAdQR.png";
import Image1 from "../Assests/slideshow/slideshow/01.webp";
import Image2 from "../Assests/slideshow/slideshow/02.webp";
import Image3 from "../Assests/slideshow/slideshow/03.webp";
import Image4 from "../Assests/slideshow/slideshow/04.webp";
import Image5 from "../Assests/slideshow/slideshow/05.webp";

const images = [Image1, Image2, Image3, Image4, Image5];

const HeroSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full relative">
      {/* Image Slider - Desktop */}
      {/* Image Slider - Desktop */}
      <div className="relative w-full 2xl:h-[740px]  min-h-[400px] overflow-hidden">
        <img
          src={images[currentIndex]}
          className="w-full h-auto 2xl:h-full min-h-[400px] object-cover transition-all duration-1000"
          alt={`slide-${currentIndex}`}
        />

        {/* Overlay Box (Desktop Only) */}
        <div
          className="hidden 2xl:flex absolute top-0 right-[60px] w-[540px] h-full text-white items-center justify-center px-[35px]"
          style={{ background: "linear-gradient(#8C0000, #FF0000)" }}
        >
          <div>
            <p className="text-[21px] text-[#FFDF9A] text-center tracking-widest font-normal uppercase">
              The Vision:
            </p>
            <h1 className="text-[58px] leading-[58px] font-semibold mb-4 tracking-tight text-center font-bold">
              ALRA TV's New Chapter
            </h1>
            <p className="text-center leading-[130%] text-[24px] mb-4 font-light">
              Help Us Build the Future of Spiritual Media
            </p>
            <div
              className="text-sm text-center my-2 uppercase opacity-80 tracking-widest
"
            >
              {" "}
              Progress(Stage 1):{" "}
            </div>
            <div className="w-[400px] h-2 bg-gray-200 rounded-xl mx-auto mb-12 opacity-99">
              <div
                className="h-full bg-yellow-500 transition-all duration-300 ease-in-out rounded-xl text-center text-xs leading-[100%] font-bold pt-0.5"
                style={{ width: `45%` }}
              ></div>
              <div className="mx-auto text-2xl text-center font-light  mt-1">
                45% of £1.5M
              </div>
            </div>
            <div className="text-center text-xs opacity-70 mt-1">
              * progress updated weekly
            </div>
            <div className="mx-auto w-[180px] my-5">
              <img src={qrCode} alt="QR Code" />
            </div>
            <div className="mx-auto w-full text-center">
              <a
                href="https://buy.stripe.com/5kA17AcGfgIRaCAdQR"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[400px] h-[56px] mx-auto inline-flex items-center justify-center border border-white border-[4px] text-white text-[24px] font-bold px-[32px] py-[14px] rounded-[24px] hover:bg-white hover:text-[#8C0000] transition hover:cursor-pointer"
              >
                DONATE NOW{" "}
                <span className="ml-2">
                  <img src={arrR} className="w-[24px]" alt="Arrow" />
                </span>
              </a>

              <a
                className="block mt-5 inline-flex items-center justify-center font-bold hover:scale-[101%]"
                target="blank"
                href="https://paypal.me/alratv?country.x=GB&locale.x=en_GB"
              >
                <svg
                  className="mr-3"
                  width="24"
                  height="25"
                  viewBox="0 0 34 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_20_14)">
                    <path
                      d="M9.71902 29.9973H3.53887C2.55005 29.9973 1.56123 29.5099 0.943213 28.7787C0.325199 28.0475 0.0779931 27.0726 0.325199 26.0977L5.64012 3.18728C6.01093 1.72491 7.24696 0.75 8.8538 0.75H19.4836C22.3265 0.75 24.9222 1.96864 26.7762 4.16219C28.5067 6.35573 29.2483 9.1586 28.6303 11.9615C27.6414 16.836 23.1917 20.2482 18.124 20.2482H14.1687C13.5507 20.2482 12.9327 20.7357 12.8091 21.345L10.955 29.0224C10.8314 29.6317 10.337 29.9973 9.71902 29.9973Z"
                      fill="white"
                    />
                    <path
                      d="M9.71902 29.9973H3.53887C2.55005 29.9973 1.56123 29.5099 0.943213 28.7787C0.325199 28.0475 0.0779931 27.0726 0.325199 26.0977L5.64012 3.18728C6.01093 1.72491 7.24696 0.75 8.8538 0.75H19.4836C22.3265 0.75 24.9222 1.96864 26.7762 4.16219C28.5067 6.35573 29.2483 9.1586 28.6303 11.9615C27.6414 16.836 23.1917 20.2482 18.124 20.2482H14.1687C13.5507 20.2482 12.9327 20.7357 12.8091 21.345L10.955 29.0224C10.8314 29.6317 10.337 29.9973 9.71902 29.9973Z"
                      fill="white"
                    />
                    <path
                      d="M31.1021 12.0833V12.4489C29.866 18.4203 24.4275 22.6855 18.2474 22.6855H15.1573L13.4269 29.6317C12.9324 31.3378 11.4492 32.4346 9.71876 32.4346H7.2467C7.37031 32.9221 7.49391 33.2876 7.86472 33.6532C8.48273 34.3844 9.34795 34.75 10.3368 34.75H15.8989C16.5169 34.75 17.0113 34.3844 17.1349 33.897L18.8654 27.1945C18.989 26.707 19.4834 26.4633 19.9778 26.4633H23.5623C28.1356 26.4633 32.2145 23.4167 33.0797 19.1514C33.5741 16.5923 32.8325 13.9113 31.1021 12.0833Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_20_14">
                      <rect
                        width="33"
                        height="34"
                        fill="white"
                        transform="translate(0.22998 0.75)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                PayPal
                <span className="ml-2">
                  <img src={arrR} className="w-[16px]e" alt="Arrow" />
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* Indicators */}
        <div className="absolute bottom-[30px] left-1/2 -translate-x-1/2 flex space-x-3 z-20">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              aria-label={`Go to slide ${i + 1}`}
              className={`h-[6px] w-[24px] rounded bg-white transition-opacity duration-300 cursor-pointer outline-none ${
                currentIndex === i ? "opacity-100" : "opacity-50"
              }`}
            />
          ))}
        </div>
      </div>

      {/* Mobile Layout (hidden on 2xl) */}
      <div
        className="2xl:hidden w-full py-10 px-6 text-white"
        style={{ background: "linear-gradient(#8C0000, #FF0000)" }}
      >
        <div className="flex flex-col items-center">
          <p className="text-[21px] text-[#FFDF9A] text-center tracking-widest font-normal uppercase">
            The Vision:
          </p>
          <h1 className="text-[36px] leading-[40px] font-semibold mb-4 tracking-tight text-center font-bold">
            ALRA TV's New Chapter
          </h1>
          <p className="text-center text-[24px] mb-4 font-light">
            Help Us Build the Future of Spiritual Media
          </p>
          <div
            className="text-sm text-center my-2 uppercase opacity-80 tracking-widest
"
          >
            {" "}
            Progress(Stage 1):{" "}
          </div>
          <div className="w-[400px] h-2 bg-gray-200 rounded-xl mx-auto mb-8 opacity-99">
            <div
              className="h-full bg-yellow-500 transition-all duration-300 ease-in-out rounded-xl text-center text-xs leading-[100%] font-bold pt-0.5"
              style={{ width: `45%` }}
            ></div>
            <div className="mx-auto text-2xl text-center font-light  mt-1">
              45% of £1.5M
            </div>
          </div>
          <div className="text-center text-xs opacity-70 my-4">
            * progress updated weekly
          </div>
          <div className="mx-auto w-[190px] mb-10">
            <img src={qrCode} alt="Arrow" />
          </div>
          <div className="mx-auto w-full text-center flex flex-col items-center justify-center ">
            <a
              href="https://buy.stripe.com/5kA17AcGfgIRaCAdQR"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-[400px] inline-flex items-center justify-center border border-white border-[4px] text-white text-[21px] font-bold px-[20px] py-[12px] rounded-[24px] hover:bg-white hover:text-[#8C0000] transition"
            >
              DONATE NOW{" "}
              <span className="ml-2">
                <img src={arrR} className="w-[24px]" alt="Arrow" />
              </span>
            </a>
            <a
              className="block mt-5 inline-flex items-center justify-center font-bold hover:scale-[101%]"
              target="blank"
              href="https://paypal.me/alratv?country.x=GB&locale.x=en_GB"
            >
              <svg
                className="mr-3"
                width="24"
                height="25"
                viewBox="0 0 34 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_20_14)">
                  <path
                    d="M9.71902 29.9973H3.53887C2.55005 29.9973 1.56123 29.5099 0.943213 28.7787C0.325199 28.0475 0.0779931 27.0726 0.325199 26.0977L5.64012 3.18728C6.01093 1.72491 7.24696 0.75 8.8538 0.75H19.4836C22.3265 0.75 24.9222 1.96864 26.7762 4.16219C28.5067 6.35573 29.2483 9.1586 28.6303 11.9615C27.6414 16.836 23.1917 20.2482 18.124 20.2482H14.1687C13.5507 20.2482 12.9327 20.7357 12.8091 21.345L10.955 29.0224C10.8314 29.6317 10.337 29.9973 9.71902 29.9973Z"
                    fill="white"
                  />
                  <path
                    d="M9.71902 29.9973H3.53887C2.55005 29.9973 1.56123 29.5099 0.943213 28.7787C0.325199 28.0475 0.0779931 27.0726 0.325199 26.0977L5.64012 3.18728C6.01093 1.72491 7.24696 0.75 8.8538 0.75H19.4836C22.3265 0.75 24.9222 1.96864 26.7762 4.16219C28.5067 6.35573 29.2483 9.1586 28.6303 11.9615C27.6414 16.836 23.1917 20.2482 18.124 20.2482H14.1687C13.5507 20.2482 12.9327 20.7357 12.8091 21.345L10.955 29.0224C10.8314 29.6317 10.337 29.9973 9.71902 29.9973Z"
                    fill="white"
                  />
                  <path
                    d="M31.1021 12.0833V12.4489C29.866 18.4203 24.4275 22.6855 18.2474 22.6855H15.1573L13.4269 29.6317C12.9324 31.3378 11.4492 32.4346 9.71876 32.4346H7.2467C7.37031 32.9221 7.49391 33.2876 7.86472 33.6532C8.48273 34.3844 9.34795 34.75 10.3368 34.75H15.8989C16.5169 34.75 17.0113 34.3844 17.1349 33.897L18.8654 27.1945C18.989 26.707 19.4834 26.4633 19.9778 26.4633H23.5623C28.1356 26.4633 32.2145 23.4167 33.0797 19.1514C33.5741 16.5923 32.8325 13.9113 31.1021 12.0833Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_20_14">
                    <rect
                      width="33"
                      height="34"
                      fill="white"
                      transform="translate(0.22998 0.75)"
                    />
                  </clipPath>
                </defs>
              </svg>
              PayPal
              <span className="ml-2">
                <img src={arrR} className="w-[16px]e" alt="Arrow" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
